var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#100F0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.0215 45.232C68.9495 47.344 71.0615 50.416 71.0615 54.064C71.0615 59.584 67.7495 64 60.1175 64H29.3975V30.4H58.6775C66.3095 30.4 68.6615 33.856 68.6615 38.944C68.6615 41.104 67.6535 43.312 66.0215 45.232ZM41.8775 38.56V42.208H53.3975C54.6455 42.208 56.1815 42.208 56.1815 40.384C56.1815 38.56 54.6455 38.56 53.3975 38.56H41.8775ZM55.7975 54.88C57.0455 54.88 58.5815 54.88 58.5815 53.104C58.5815 51.328 57.0455 51.328 55.7975 51.328H41.8775V54.88H55.7975Z",
    fill: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationImg);
export default __webpack_public_path__ + "static/media/notificationImg.475475b2749cffd625a3c4fe517cee10.svg";
export { ForwardRef as ReactComponent };